var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.663 3.67a4.73 4.73 0 0 0-1.068 2.341L2 15.491 4.508 18l9.48-6.595A4.73 4.73 0 1 0 9.664 3.67Zm.263 6.404c.473.473 1.04.84 1.665 1.08l-6.9 4.8-.645-.644 4.802-6.902a4.744 4.744 0 0 0 1.078 1.666Zm6.463-3.805c.1.673-.02 1.359-.343 1.957-.783-.253-2.01-1.055-2.613-1.66-.614-.612-1.434-1.86-1.672-2.605a3.153 3.153 0 0 1 4.628 2.308Zm-3.512 3.59a3.153 3.153 0 0 0 1.995-.413c-.945-.44-1.933-1.143-2.554-1.764a9.755 9.755 0 0 1-1.771-2.54 3.153 3.153 0 0 0 2.33 4.717Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.e7c28ef6.svg";
export { ForwardRef as ReactComponent };